export enum CollectionAgencyTypes {
  None                  = 0,
  PayRoute              = 1,
  PayPalAndCramSchool   = 2,
  PayPalAndOther        = 3,
  UnivaPay              = 4,
}
